module.exports = __webpack_public_path__ + "media/images/default_user_icon-4c9d94dccb616cdc520ec48b947e0c49.jpg";